/* eslint-disable no-func-assign */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

import * as _core from '@emotion/react';

import * as _polished from 'polished';

import * as _high_contrast_media_query from '../utils/high_contrast_media_query';

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

var styles = function styles(_ref) {
  var disabled = _ref.disabled,
    focusVisible = _ref.focusVisible,
    movementStarted = _ref.movementStarted,
    theme = _ref.theme,
    trackWidth = _ref.trackWidth,
    isVertical = _ref.isVertical,
    tooltipWidth = _ref.tooltipWidth,
    isRTL = _ref.isRTL;

  return /*#__PURE__*/ (0, _core.css)(
    _extends(
      {
        alignItems: 'center',
        cursor: disabled ? 'default' : 'pointer',
        display: 'flex',
        width: isVertical ? theme.orbitalSix : '100%'
      },
      isVertical && {
        height: '100%',
        flexDirection: 'column-reverse'
      },
      {
        '.side': {
          alignItems: 'center',
          display: 'flex',
          flexDirection: isVertical ? 'column-reverse' : 'row',
          height: isVertical
            ? 'calc('.concat(theme.orbitalSix, ' / 2)')
            : theme.orbitalSix,
          width: isVertical
            ? theme.orbitalSix
            : 'calc('.concat(theme.orbitalSix, ' / 2)'),
          '&--minimum': {
            backgroundColor: disabled
              ? theme.colorDisabledForeground
              : theme.colorControlBackgroundChecked,
            borderRadius: ''
              .concat(theme.borderRadius, ' 0 0 ')
              .concat(theme.borderRadius),
            height: isVertical
              ? 'calc('.concat(theme.orbitalSix, ' / 2)')
              : '4px',
            width: isVertical
              ? '4px'
              : 'calc('.concat(theme.orbitalSix, ' / 2)')
          },
          '&--maximum': {
            backgroundColor: theme.colorControlRail,
            height: isVertical
              ? 'calc('.concat(theme.orbitalSix, ' / 2)')
              : '1px',
            width: isVertical
              ? '1px'
              : 'calc('.concat(theme.orbitalSix, ' / 2)')
          }
        },
        '.bar': {
          alignItems: 'center',
          display: 'flex',
          height: isVertical ? '100%' : theme.orbitalSix,
          position: 'relative',
          width: isVertical ? theme.orbitalSix : '100%',
          flexDirection: isVertical ? 'column-reverse' : 'row',
          '.rail': {
            backgroundColor: theme.colorControlRail,
            height: isVertical ? '100%' : '1px',
            width: isVertical ? '1px' : '100%'
          },
          '.track': _extends(
            {
              backgroundColor: disabled
                ? theme.colorDisabledForeground
                : theme.colorControlBackgroundChecked,
              height: isVertical ? ''.concat(trackWidth, '%') : '4px',
              position: 'absolute',
              width: isVertical ? '4px' : ''.concat(trackWidth, '%')
            },
            isVertical
              ? {
                  bottom: 0
                }
              : {
                  left: 0
                }
          ),
          '.thumb': _extends(
            {
              backgroundColor: disabled
                ? theme.colorDisabledForeground
                : theme.colorControlBackgroundChecked,
              borderRadius: '100%',
              height: theme.orbitalSix,
              left: isVertical
                ? '50%'
                : 'calc('
                    .concat(trackWidth, '% - (')
                    .concat(theme.orbitalSix, ' / 2))'),
              position: 'absolute',
              transform: isVertical ? 'translateX(-50%)' : 'translateY(-50%)',
              transition: 'background-color 150ms',
              width: theme.orbitalSix
            },
            isVertical
              ? {
                  bottom: 'calc('
                    .concat(trackWidth, '% - (')
                    .concat(theme.orbitalSix, ' / 2))')
                }
              : {
                  top: '50%'
                },
            {
              '&::before': _extends(
                {
                  borderColor: theme.colorBorderFocus,
                  borderRadius: '100%',
                  borderStyle: 'solid',
                  borderWidth: '2px',
                  content: "' '",
                  opacity: 0,
                  transition: 'all 150ms'
                },
                (0, _polished.position)('absolute', 0),
                focusVisible &&
                  _extends(
                    {
                      opacity: 1
                    },
                    (0, _polished.position)('absolute', '-4px')
                  )
              )
            },
            !disabled &&
              _extends(
                {},
                !movementStarted && {
                  '&:hover': {
                    backgroundColor: !disabled && theme.colorPrimaryHover
                  }
                },
                movementStarted && {
                  backgroundColor: theme.colorPrimaryActive
                }
              )
          )
        },
        '.tooltip': _extends(
          {
            position: 'absolute',
            transform: isVertical ? 'translateX(-100%)' : 'translateY(-100%)'
          },
          isVertical
            ? {
                bottom: 'calc('
                  .concat(trackWidth, '% - (')
                  .concat(theme.orbitalSix, ' / 2))')
              }
            : {
                left:
                  typeof isRTL !== 'undefined' && isRTL
                    ? 'calc(' +
                      (100 - trackWidth) +
                      '% - (' +
                      tooltipWidth +
                      'px / 2))'
                    : 'calc(' + trackWidth + '% - (' + tooltipWidth + 'px / 2))'
              }
        )
      },
      (0, _high_contrast_media_query.default)(theme)
    ),
    process.env.NODE_ENV === 'production'
      ? ''
      : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
  );
};

var _default = styles;
export default _default;
